import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: string; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Joystance error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-screen flex flex-col items-center justify-center bg-stabeon-bg px-8 text-center">
          <div className="text-6xl mb-6">😵</div>
          <h1 className="text-2xl font-bold text-stabeon-text mb-2">Something went wrong</h1>
          <p className="text-stabeon-muted text-sm mb-2 max-w-xs">
            The app hit an unexpected error. Your data is safe.
          </p>
          <p className="text-stabeon-muted/50 text-xs mb-8 max-w-xs font-mono break-all">
            {this.state.error}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary px-8"
          >
            Reload app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
